<template>
  <div>
    <CCard>
      <CCardHeader class="d-flex justify-content-between align-items-center">
        <h3 style="margin-top: 8px; display: inline-block">
          Editar concurso: {{ nombreConcurso }}
        </h3>
      </CCardHeader>
      <CCardBody>
        <CInput
          label="Nombre del concurso *"
          type="text"
          v-model="concurso.nombre"
          @change="handleNombreConcurso"
          horizontal
        />
        <CTextarea
          label="Descripción *"
          v-model="concurso.descripcion"
          type="text"
          @change="handleDescripcion"
          horizontal
        />
        <CInput
          label="Número de expediente *"
          v-model="concurso.numeroExpediente"
          type="text"
          @change="handleNombreExpediente"
          horizontal
        />
        <!--<CSelect
          label="Tipo de concurso *"
          :options="typeOptions"
          @change="handleType"
          horizontal
        ></CSelect>-->

        <CSelect
          label="Modelo de cálculo *"
          :options="modelosCalculoSelect"
          v-model="concurso.nombreCalculo"
          :disabled="true"
          @change="handleCalc"
          placeholder="Seleccionar modelo de cálculo"
          horizontal
        ></CSelect>
        <CRow style="margin-bottom: 15px" v-if="concurso.criteriosEvaluacion">
          <CCol sm="3"></CCol>
          <CCol sm="9">{{ criterioSeleccionado.descripcion }}</CCol>
        </CRow>

        <CRow>
          <CCol sm="3"> Criterios de evaluacion </CCol>
          <CCol sm="9">
            <CRow>
              <CCol sm="12" style="margin-top: 10px">
                <CCard
                  v-if="
                    concurso.criteriosEvaluacion &&
                    concurso.criteriosEvaluacion.length > 0
                  "
                >
                  <CCardHeader>
                    <CRow>
                      <CCol sm="4"> Criterio </CCol>
                      <CCol sm="4">Descripción</CCol>
                      <CCol sm="3"> Peso </CCol>
                      <CCol sm="1"> </CCol>
                    </CRow>
                  </CCardHeader>
                  <CCardBody>
                    <CRow
                      style="margin-top: 10px"
                      v-for="(criterio, index) in concurso.criteriosEvaluacion"
                      :key="index"
                    >
                      <CCol sm="4">
                        <CSelect
                          v-if="!criterio.nombreCriterio"
                          :disabled="true"
                          placeholder="Seleccionar criterio"
                          :options="listaNombresCriterios"
                          @focus="seleccionarCriterio(index)"
                          @change="setCriterio"
                          horizontal
                        ></CSelect>
                        <b v-if="criterio.nombreCriterio">{{
                          criterio.nombreCriterio
                        }}</b>
                      </CCol>
                      <CCol sm="5">{{
                        getDescripcionCriterio(criterio.idCriterioEvaluacion)
                      }}</CCol>
                      <CCol sm="3">
                        <CInput
                          :disabled="true"
                          type="number"
                          placeholder="Peso"
                          v-model="criterio.peso"
                          @focus="seleccionarCriterio(index)"
                          @input="setPeso"
                        />
                      </CCol>
                      <!--<CCol sm="1">
                        <CButton color="danger" @click="eliminarCriterio(index)"
                          ><CIcon name="cil-trash"
                        /></CButton>
                      </CCol>-->
                    </CRow>
                  </CCardBody>
                </CCard>
                <div
                  v-if="listaCriterios.length == 0"
                  style="margin-bottom: 15px"
                >
                  Sin criterios
                </div>
              </CCol>
            </CRow>
          </CCol>
        </CRow>

        <CRow>
          <CCol sm="3">Expedientes </CCol>
          <CCol sm="9">
            <CRow>
              <CCol sm="12" style="margin-bottom: 15px"
                ><CButton color="secondary" @click="añadirExpediente()"
                  >Añadir expediente</CButton
                ></CCol
              >
              <CCol
                sm="12"
                v-if="listaExpedientes.length > 0"
                style="margin-top: 10px"
              >
                <CCard>
                  <CCardBody>
                    <CRow
                      v-for="(expediente, index) in listaExpedientes"
                      :key="index"
                    >
                      <CCol sm="3">
                        <div style="margin-top: 10px">
                          Exp {{ index + 1 }}: {{ concurso.numeroExpediente }}
                        </div>
                      </CCol>
                      <CCol sm="8">
                        <CInput
                          type="text"
                          style="margin-top: 5px; margin-bottom: 5px"
                          :value="expediente.nombre"
                          @focus="seleccionarExpediente(index)"
                          @input="handleExpediente"
                        />
                      </CCol>
                      <CCol sm="1">
                        <CButton
                          color="danger"
                          @click="eliminarExpediente(index)"
                          ><CIcon name="cil-trash"
                        /></CButton>
                      </CCol>
                    </CRow>
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </CCol>
        </CRow>

        <CTextarea
          label="Comentarios"
          v-model="concurso.comentarios"
          type="text"
          @change="handleComentarios"
          horizontal
        />
      </CCardBody>
      <CCardFooter>
        <CButton
          color="success"
          style="float: right"
          @click="actualizarDatosConcurso"
          >Guardar cambios</CButton
        >
      </CCardFooter>
    </CCard>

    <CModal title="Información" :show.sync="showEvento" size="sm" centered>
      <div v-html="mensajeEvento">{{ mensajeEvento }}</div>

      <template #footer>
        <CButton @click="showEvento = false" color="danger">Aceptar</CButton>
      </template>
    </CModal>
  </div>
</template>

<style scoped>
</style>

<script>
import Cookies from "js-cookie";
import {
  getCriteriosConcurso,
  getModelosCalculo,
  actualizarExpediente,
  actualizarConcurso,
  crearExpediente,
  eliminarExpediente,
  añadirCriterioAConcurso,
  getDetallesConcurso,
} from "../../requests/concursos";
import { getTiposDeLote, getEstadoConcursos } from "../../requests/utilities";
import { logOut } from "../../utils/authUtils";
import { parse } from "@babel/core";

export default {
  name: "NuevoConcurso",
  components: {},
  created() {},
  mounted() {
    getDetallesConcurso(this.$route.query.idConcurso).then((res) => {
      this.concurso = res.data;
      this.nombreConcurso = res.data.nombre;
      this.listaExpedientes = this.concurso.expedientes;

      getCriteriosConcurso()
        .then((res) => {
          this.listaCriteriosBase = res.data;
          this.setNombreCriterios();
        })
        .catch((error) => {
          if (error.response.status == 403 || error.response.status == 401)
            logOut(this.$router);
        });

      getModelosCalculo()
        .then((res) => {
          this.modelosCalculo = res.data;
          this.concurso.idCalculo = this.modelosCalculo[0].id;
          this.modelosCalculo.forEach((calc) => {
            this.modelosCalculoSelect.push(calc.nombre);
          });

          this.findModeloCalculo(this.concurso.idCalculo);
        })
        .catch((error) => {
          console.log(error);
        });
      console.log(this.concurso);
    });

    getTiposDeLote()
      .then((res) => {
        this.types = res.data;
        this.types.forEach((type) => {
          this.typeOptions.push(type.descripcion);
        });
      })
      .catch((error) => {
        if (error.response.status == 403 || error.response.status == 401)
          logOut(this.$router);
      });

    getEstadoConcursos()
      .then((res) => {
        this.estados = res.data;
        this.estados.forEach((type) => {
          this.estadoOptions.push(type.descripcion);
        });
      })
      .catch((error) => {
        if (error.response.status == 403 || error.response.status == 401)
          logOut(this.$router);
      });
  },
  data() {
    return {
      nombreConcurso: "",
      concurso: {
        nombre: "",
        descripcion: "",
        numeroExpediente: "",
        idCalculo: 0,
        comentarios: "",
      },
      mensajeEvento: "", //mensaje y booleana para mostrar informacion en un modal
      showEvento: false,
      modelosCalculo: [],
      modelosCalculoSelect: [],
      types: [],
      typeOptions: [],
      calculoSeleccionado: undefined,
      estados: [],
      estadoOptions: [],
      listaCriteriosBase: [], //Lista de criterios recogida del endpoint
      listaNombresCriterios: [], //select de criterios
      listaCriterios: [], //criterios seleccionados
      criterioSeleccionado: 0, //index del criterio seleccionado al hacer click en el select
      listaExpedientes: [],
      listaExpedientesABorrar: [], //lista de expedientes que se van a borrar
      expedienteSeleccionado: 0,
    };
  },
  methods: {
    añadirCriterio() {
      //Añade un criterio vacio a la lista de criterios
      if (this.listaCriterios.length < this.listaCriteriosBase.length)
        this.listaCriterios.push({
          nombre: "",
          descripcion: "",
          peso: 0,
        });
    },
    setNombreCriterios() {
      //Inicia la lista del select de los criterios de evaluacion
      this.listaNombresCriterios = [];
      this.listaCriteriosBase.forEach((criterio) => {
        this.listaNombresCriterios.push(criterio.nombre);
      });
    },
    setNombreCriteriosModif() {
      //Despues de seleccionar un criterio, rehace el select de criterios para que los seleccionados no aparezcan
      this.listaNombresCriterios = [];
      this.listaCriteriosBase.forEach((criterio) => {
        let found = false;
        this.listaCriterios.forEach((critSel) => {
          if (critSel.nombre == criterio.nombre) found = true;
        });
        if (!found) this.listaNombresCriterios.push(criterio.nombre);
      });
    },
    seleccionarCriterio(index) {
      console.log(index);
      this.criterioSeleccionado = index;
    },
    setCriterio(event) {
      //añade un criterio a la lista, y reorganiza el desplegable de criterios para que no salgan criterios ya elegidos
      let index;
      this.listaCriteriosBase.forEach((criterio, i) => {
        if (criterio.nombre == event.target.value) index = i;
      });
      this.listaCriterios[this.criterioSeleccionado] = this.listaCriteriosBase[
        index
      ];
      this.setNombreCriteriosModif(); //reorganiza el desplegable
      this.$forceUpdate();
    },
    calcularPesoMaximo(value) {
      //calcula el peso máximo en base al resto de pesos
      let pesoMax = 100;
      this.listaCriterios.forEach((crit) => {
        if (crit.peso && this.listaCriterios[this.criterioSeleccionado] != crit)
          pesoMax -= Math.max(crit.peso, 0);
      });
      console.log(Math.min(value, pesoMax));
      return Math.min(value, pesoMax);
    },
    setPeso(value) {
      //modifica el peso de un criterio de evaluacion
      if (this.calcularPesoMaximo(100) > 0)
        //si todavia queda peso por asignar
        this.listaCriterios[
          this.criterioSeleccionado
        ].peso = this.calcularPesoMaximo(parseInt(value));
      else this.listaCriterios[this.criterioSeleccionado].peso = 0;
      console.log(this.listaCriterios[this.criterioSeleccionado]);
    },
    eliminarCriterio(index) {
      //elimina un criterio de evaluacion
      this.listaCriterios.splice(index, 1);
      this.setNombreCriteriosModif();
      this.$forceUpdate();
    },
    añadirExpediente() {
      this.listaExpedientes.push({
        nombre: ""
      });
    },
    eliminarExpediente(index) {
      if(this.listaExpedientes[index].id)
        this.listaExpedientesABorrar.push(this.listaExpedientes[index]);
      console.log(index);
      console.log(this.listaExpedientes)
      this.listaExpedientes.splice(index, 1);
    },
    seleccionarExpediente(index) {
      this.expedienteSeleccionado = index;
    },
    handleExpediente(value) {
      this.listaExpedientes[this.expedienteSeleccionado].nombre = value;
      console.log(this.listaExpedientes[this.expedienteSeleccionado]);
    },
    getDescripcionCriterio(idCriterioEvaluacion) {
      let desc = "";
      this.listaCriteriosBase.forEach((criterio) => {
        if (criterio.id == idCriterioEvaluacion) {
          desc = criterio.descripcion;
        }
      });
      return desc;
    },
    findModeloCalculo(idCalculo) {
      this.modelosCalculo.forEach((modelo, index) => {
        if (this.modelosCalculo[index].id == idCalculo)
          this.criterioSeleccionado = this.modelosCalculo[index];
      });

      this.listaCriterios = [];
      this.criterioSeleccionado.criterios.split(",").forEach((id, index) => {
        this.listaCriteriosBase.forEach((criterio) => {
          if (criterio.id == id) {
            this.listaCriterios.push(criterio);
          }
        });
      });
    },
    handleCalc(event) {
      //añade a la lista de criterios todos los criterios presentes en el modelo de calculo seleccionado
      let index = this.modelosCalculoSelect.indexOf(event.target.value);
      this.criterioSeleccionado = this.modelosCalculo[index];
      this.listaCriterios = [];
      this.criterioSeleccionado.criterios.split(",").forEach((id, index) => {
        this.listaCriteriosBase.forEach((criterio) => {
          if (criterio.id == id) {
            this.listaCriterios.push(criterio);
          }
        });
      });
      this.concurso.idCalculo = this.modelosCalculo[index].id;
    },
    //controla los atributos de los inputs del formulario
    handleNombreConcurso(value) {
      this.concurso.nombre = value;
    },
    handleDescripcion(value) {
      this.concurso.descripcion = value;
    },
    handleNombreExpediente(value) {
      this.concurso.numeroExpediente = value;
    },
    handleComentarios(value) {
      this.concurso.comentarios = value;
    },
    reiniciarCampos() {
      this.concurso = {
        nombre: "",
        descripcion: "",
        numeroExpediente: "",
        idCalculo: 0,
        comentarios: "",
      };
      this.listaExpedientes = [];
    },
    checkValores() {
      //comprobaciones antes de crear el concurso
      let pesoTotal = 0;
      /*this.listaCriterios.forEach((crit) => {
        pesoTotal += crit.peso;
        if (crit.nombre == "") valoresCriterios = false;
      });*/

      if (
        this.concurso.nombre == "" ||
        this.concurso.descripcion == "" ||
        this.concurso.numeroExpediente == "" ||
        this.concurso.idCalculo == 0
      ) {
        this.mensajeEvento = "Faltan campos por rellenar.";
        this.showEvento = true;
        return false;
      }
      /*
      if (this.listaCriterios.length == 0) {
        this.mensajeEvento =
          "No se ha añadido seleccionado ningún modelo de cálculo.";
        this.showEvento = true;
        return false;
      }

      if (pesoTotal != 100) {
        this.mensajeEvento =
          "La suma de pesos de los criterios de evaluación es distinta a 100.";
        this.showEvento = true;
        return false;
      }*/

      return true;
    },

    mostrarInformacion(mensaje) {
      //muestra informacion usando el modal de modificar
      this.mensajeEvento = mensaje;
      this.showEvento = true;
    },

    actualizarDatosConcurso() {
      if (!this.checkValores()) {
        //comprueba que los campos son validos
        return;
      }

      let infoConcurso = {
        nombre: this.concurso.nombre,
        descripcion: this.concurso.descripcion,
        numeroExpediente: this.concurso.numeroExpediente,
        idCalculo: this.concurso.idCalculo,
        idEstadoConcurso: this.concurso.idEstadoConcurso,
        comentarios: this.concurso.comentarios,
      };

      actualizarConcurso(this.concurso.id, infoConcurso)
        .then((res) => {
          let expedientesModificados = 0;
          let expedientesBorrados = 0;
          this.listaExpedientesABorrar.forEach((expediente) => {
            if (expediente.id) {
              eliminarExpediente(expediente.id)
                .then((resExp) => {
                  expedientesBorrados++;
                  if (
                    expedientesModificados == this.listaExpedientes.length &&
                    expedientesBorrados == this.listaExpedientesABorrar.length
                  ) {
                    this.mostrarInformacion(
                      "Concurso modificado correctamente."
                    );
                  }
                  console.log(resExp.data);
                })
                .catch((error) => {
                  this.mostrarInformacion(
                    "No se ha podido actualizar el expediente " +
                      expediente.nombre +
                      ". Causa: " +
                      error.response.data.error
                  );
                });
            }
          });
          this.listaExpedientes.forEach((expediente) => {
            if (expediente.id) {
              actualizarExpediente(expediente.id, expediente.nombre)
                .then((resExp) => {
                  expedientesModificados++;
                  if (expedientesModificados == this.listaExpedientes.length &&
                    expedientesBorrados == this.listaExpedientesABorrar.length) {
                    this.mostrarInformacion(
                      "Concurso modificado correctamente."
                    );
                  }
                  console.log(resExp.data);
                })
                .catch((error) => {
                  this.mostrarInformacion(
                    "No se ha podido actualizar el expediente " +
                      expediente.nombre +
                      ". Causa: " +
                      error.response.data.error
                  );
                });
            } else {
              crearExpediente({
                idConcurso: this.concurso.id,
                nombre: expediente.nombre,
              })
                .then((resExp) => {
                  expedientesModificados++;
                  if (expedientesModificados == this.listaExpedientes.length &&
                    expedientesBorrados == this.listaExpedientesABorrar.length) {
                    this.mostrarInformacion(
                      "Concurso modificado correctamente."
                    );
                  }
                  console.log(resExp.data);
                })
                .catch((error) => {
                  this.mostrarInformacion(
                    "No se ha podido actualizar el expediente " +
                      expediente +
                      ". Causa: " +
                      error.response.data.error
                  );
                });
            }
          });
        })
        .catch((error) => {
          this.mostrarInformacion(
            "No se ha podido actualizar el concurso. Causa: " +
              error.response.data.error
          );
        });
    },
  },
  beforeDestroy() {},
};
</script>
